import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-6 py-3"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import PatientLayout from '../components/PatientLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import StatusPill from '@/components/StatusPill.vue';
import PageLoader from '@/components/PageLoader.vue';
import PagePagination from '@/components/PagePagination.vue';
import Patient from '@/classes/Patient'; 

import { useRouter, useRoute } from 'vue-router';
import { onMounted, ref, computed, watch } from 'vue';
import { format } from 'date-fns';
import { useNetworkStore } from '@/store/network';
import { onIonViewWillEnter } from '@ionic/vue';
import { formatDateTime } from '@/helpers/TimeFormatter'


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const patientId = ref(route.params.id);

// Data
const loader    = ref(true);
const showError = ref(false);
const errorMsg  = ref(null);

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

// Query
const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();

// Page Renderer Data
const items       = ref(null);
const items_count = ref(0);
const query       = ref(null);

const tabs: { name: string, count: number, href: string, allowed: true }[] = [
    {
        name: 'Active',
        count: 0,
        href: '/accounts/patients/bookings/' + patientId.value,
        allowed: true
    }
];

const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Patient' },
    { text: 'Status' },
    { text: 'Date Created'}
];

const indexBookings = (data: string) => {
    loader.value = true;

    // console.log(isNetworkAvailable.value)

    if(isNetworkAvailable.value) {
        console.log("Online - Fetching Patient Bookings...")

        const pageNum = data?.match(/\d+/)[0] ? data?.match(/\d+/)[0] : 1;
        const queryString =  searchText.value ? `&query=${searchText.value}` : ''
        const additionalparam = `&page_number=${pageNum}&per_page=10&${queryString}&requested_at=${new Date().toISOString()}`
    
        goToPage.value = data ? `page=${pageNum}` : 'page=1';
    
        Patient.showPatientBookings(patientId.value, goToPage.value + additionalparam)
            .then((response: any) => {
                loader.value      = false;
                items.value       = response.data;
                items_count.value = response.data.total
                query.value       = response.data.query
            })
            .catch((err) => {
                loader.value    = false;
                showError.value = true;
                errorMsg.value  = err.response.data.message;
                
                if(err.response.status == 401) {
                    window.location.replace('/login');
                }
            })
    } else {
        console.log("Offline - Fetching Patient Bookings...")

        const pageNum = data?.match(/\d+/)[0] ? data?.match(/\d+/)[0] : 1;

        Patient.showPatientBookings(patientId.value, `page=${pageNum}&page_number=${pageNum}&per_page=10`)
        .then((response: any) => {
            loader.value      = false;
            items.value       = response.data;
            items_count.value = response.data.total
            query.value       = response.data.query
        })
        .catch(() => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value = "Oppps... No available data was saved for offline use.";
        })
    }
}

const getStatusColor = (status: string) => {
    if(status) {
        let color = null;
        switch (status) {
            case 'Booked':
                color = 'blue';
                break;
        
            case 'Cancelled/No-Show':
            case 'Cancelled':
                color = 'red';
                break;
        
            case 'Done':
                color = 'green';
                break;
            
            default:
                color = 'yellow'
                break;
        }

        return color;
    }

    return 'yellow';
}

watch(
    () => isNetworkAvailable.value,
    () => {
        indexBookings(goToPage.value);
    }
);

onMounted(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        indexBookings(goToPage.value);
    }, 1000);
})

onIonViewWillEnter(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        indexBookings(goToPage.value);
    }, 1000);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Bookings",
    "show-back": "",
    backUrl: `/accounts/patients`
  }, {
    default: _withCtx(() => [
      _createVNode(PatientLayout, { "patient-id": patientId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(TabComponent, {
              tabs: tabs,
              "button-items": true
            }, _createSlots({ _: 2 }, [
              (isNetworkAvailable.value)
                ? {
                    name: "buttons",
                    fn: _withCtx(() => [
                      _createVNode(ButtonComponent, {
                        class: "text-gray-900",
                        secondary: "",
                        exportBtn: ""
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" Export ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024)
          ]),
          (isNetworkAvailable.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(FilterComponent, {
                  search: searchText.value,
                  "onUpdate:searchText": _cache[0] || (_cache[0] = (value) => (searchText.value = value)),
                  "sidebar-filters": false,
                  "custom-filters": activeTab.value !== 'activity_logs'
                }, null, 8, ["search", "custom-filters"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(DataTable, {
              headers: headers,
              count: items.value?.total
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, key) => {
                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                    _createElementVNode("td", _hoisted_3, _toDisplayString(item.booking_id), 1),
                    _createElementVNode("td", _hoisted_4, _toDisplayString(item.patient?.first_name) + " " + _toDisplayString(item.patient?.last_name), 1),
                    _createElementVNode("td", _hoisted_5, [
                      _createVNode(StatusPill, {
                        color: getStatusColor(item.status),
                        text: item.status
                      }, null, 8, ["color", "text"])
                    ]),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formatDateTime)(item.booking_created_date)), 1),
                    _createElementVNode("td", _hoisted_7, [
                      _createVNode(ActionButton, {
                        "edit-btn": "",
                        onClick: ($event: any) => (_unref(router).push(`/accounts/patients/${patientId.value}/bookings/show/` + item.booking_id))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["count"]),
            _createVNode(PagePagination, {
              class: "mb-6",
              items: items.value,
              onNextPage: indexBookings
            }, null, 8, ["items"])
          ])
        ]),
        _: 1
      }, 8, ["patient-id"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})